import { useEffect, useState } from 'react';
import api from '@/api';
import { History } from 'lucide-react';

const StatusBadge = ({ status }) => {
  const map = {
    pending: 'bg-amber-50 text-amber-700',
    accepted: 'bg-green-50 text-green-700',
    rejected: 'bg-red-50 text-red-700',
  };
  return (
    <span className={`text-xs font-semibold px-2.5 py-0.5 rounded-full ${map[status] || 'bg-slate-50 text-slate-600'}`}>
      {status}
    </span>
  );
};

export default function FreightHistory() {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get('/offers/')
      .then((r) => {
        setOffers((r.data || []).filter((o) => o.platform === 'freightiq'));
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-5" data-testid="freight-history-page">
      <div>
        <h1 className="font-heading text-2xl font-bold text-slate-900">Freight history</h1>
        <p className="text-slate-500 text-sm mt-0.5">All freight quotes (pending, accepted, and declined)</p>
      </div>

      {loading ? (
        <div className="space-y-3">
          {[1, 2, 3].map((i) => (
            <div key={i} className="h-14 bg-white rounded-xl border animate-pulse" />
          ))}
        </div>
      ) : offers.length === 0 ? (
        <div className="bg-white rounded-xl border border-slate-200 p-12 text-center">
          <History className="w-10 h-10 text-slate-300 mx-auto mb-3" />
          <p className="text-slate-500 font-medium">No freight offer history yet</p>
        </div>
      ) : (
        <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
          <table className="w-full" data-testid="freight-history-table">
            <thead>
              <tr className="border-b border-slate-100">
                <th className="text-left px-5 py-3.5 text-xs font-semibold text-slate-500 uppercase tracking-wider">Forwarder</th>
                <th className="text-left px-5 py-3.5 text-xs font-semibold text-slate-500 uppercase tracking-wider">Quote</th>
                <th className="text-left px-5 py-3.5 text-xs font-semibold text-slate-500 uppercase tracking-wider hidden md:table-cell">Notes</th>
                <th className="text-left px-5 py-3.5 text-xs font-semibold text-slate-500 uppercase tracking-wider hidden lg:table-cell">Date</th>
                <th className="text-left px-5 py-3.5 text-xs font-semibold text-slate-500 uppercase tracking-wider">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50">
              {offers.map((o) => (
                <tr key={o._id} className="hover:bg-slate-50 transition-colors">
                  <td className="px-5 py-4 text-sm font-semibold text-slate-900">{o.supplier_name}</td>
                  <td className="px-5 py-4 text-sm font-bold text-slate-900">
                    ${o.amount?.toLocaleString()} {o.currency}
                  </td>
                  <td className="px-5 py-4 hidden md:table-cell text-sm text-slate-500 line-clamp-1">{o.notes || '—'}</td>
                  <td className="px-5 py-4 hidden lg:table-cell text-sm text-slate-500">
                    {o.created_at ? new Date(o.created_at).toLocaleDateString() : '—'}
                  </td>
                  <td className="px-5 py-4">
                    <StatusBadge status={o.status} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
